import VariantUpdate from '../variant-update'

class VariantUpdateManager {
    constructor() {
        this._init()
    }
    _init() {
        document.querySelectorAll('[data-variants]').forEach(el => {
            el.variant = new VariantUpdate(el)
        })
    }
}

export default VariantUpdateManager